import React from 'react';

const ThreeDotIcon = () => {
    return (
        <svg className={`svg-inline`} viewBox="0 0 10 3" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.81519 2.24902C2.09133 2.24902 2.31519 2.02517 2.31519 1.74902C2.31519 1.47288 2.09133 1.24902 1.81519 1.24902C1.53904 1.24902 1.31519 1.47288 1.31519 1.74902C1.31519 2.02517 1.53904 2.24902 1.81519 2.24902Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.31519 2.24902C5.59133 2.24902 5.81519 2.02517 5.81519 1.74902C5.81519 1.47288 5.59133 1.24902 5.31519 1.24902C5.03904 1.24902 4.81519 1.47288 4.81519 1.74902C4.81519 2.02517 5.03904 2.24902 5.31519 2.24902Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.81519 2.24902C9.09133 2.24902 9.31519 2.02517 9.31519 1.74902C9.31519 1.47288 9.09133 1.24902 8.81519 1.24902C8.53904 1.24902 8.31519 1.47288 8.31519 1.74902C8.31519 2.02517 8.53904 2.24902 8.81519 2.24902Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ThreeDotIcon;
